<template>
    <div id="thingjs-x-pop-up">
        <main>
            <article>
                <div class="head">
                    <span class="title">
                        {{ propContent.title }}
                    </span>
                    <span class="cancel" @click="cancal()">×</span>
                </div>
                <div class="content">
                    <img v-if="!isVideo" :src="propContent.clickImgBgUrl" :alt="propContent.title">
                    <video
                        v-else
                        :src="propContent.clickImgBgUrl"
                        autoplay="autoplay"
                        controls="controls"
                        class="model-review"
                        loop="loop"
                        muted="muted"
                    >
                    </video>
                </div>
            </article>
        </main>
    </div>
</template>

<script>
export default {
    data () {
        return {
            isVideo: ''
        }
    },
    props: {
        propContent:{
            type: Object,
            defaule: {

            }
        }
    },
    created () {
        if( this.propContent.clickImgBgUrl.includes('.mp4') ||
            this.propContent.clickImgBgUrl.includes('.mov') ||
            this.propContent.clickImgBgUrl.includes('.MOV')){
            this.isVideo = true;
        }

    },
    mounted () {
        if(this.propContent.code === "lowCode"){
            $('#thingjs-x-pop-up main article').css({"height":"auto","max-height":"100%"})
            $('#thingjs-x-pop-up main article .content img').css("height","auto")
        }
    },
    methods: {
        // 取消按钮
        cancal(){
            this.$emit('cancel', false);
            document.documentElement.style.cssText = 'overflow:initial;';
            document.body.style.cssText = 'overflow:initial;padding:0;';
        }
    }
}
</script>

<style lang = "less" scoped>
    #thingjs-x-pop-up{
        main{
            position: fixed;
            top: 0px;
            right: 0px;
            bottom: 0px;
            left: 0px;
            display: flex;
            -webkit-box-pack: center;
            justify-content: center;
            -webkit-box-align: center;
            align-items: center;
            width: 100vw;
            height: 100vh;
            z-index: 5000;
            background: rgba(0, 0, 0, 0.85);
            article{
                box-sizing: border-box;
                width: 75vw;
                height: 85vh;
                max-height: 85vh;
                padding: 13px 12px 20px;
                border-radius: 4px;
                background: rgb(255, 255, 255);
                .head{
                    padding-bottom: 14px;
                    margin-bottom: 20px;
                    border-bottom: 1px solid rgb(238, 238, 238);
                    display: flex;
                    justify-content: space-between;
                    align-content: center;
                    position: relative;
                    .title{
                        color: rgb(102, 102, 102);
                        font-weight: 600;
                        font-size: 12px;
                        line-height: 12px;
                    }
                    .cancel{
                        font-size: 23px;
                        cursor: pointer;
                        position: absolute;
                        right: 0;
                        top: -9px;
                    }
                }
                .content{
                    height: calc(100% - 47px);
                    background-color: rgba(243, 240, 240, 0.5);
                    border-radius: 8px;
                    img{
                            width: 100%;
                            height: 100%;
                            border-radius: 8px;
                    }
                    video{
                        width: 100%;
                        height: 100%;
                        border-radius: 8px;
                        object-fit: fill;
                    }
                }
            }
        }
    }
    @media (max-width: 1480px) {
        #thingjs-x-pop-up{
            main{
                article{
                    height: auto;
                    .content{
                        img{

                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/thingjs-x/thingjsXPopUp.vue